export const readFileDataAsBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event: any) => {
            resolve(event.target.result.substr(event.target.result.indexOf(',') + 1));
        };

        reader.onerror = (err) => {
            reject(err);
        };

        reader.readAsDataURL(file);
    });
}

export const getImageUrl = (path: string) => {
    if (!path) {
        return "";
    }

    if (path.startsWith("data:")) {
        return path;
    }

    const apiBaseUrl = process.env.REACT_APP_API_URL?.trim() ?? "";
    const proxyEndpoint = "/api/images/proxy";

    return `${apiBaseUrl}${proxyEndpoint}?uri=${encodeURIComponent(path)}`;
}
